import { render, staticRenderFns } from "./GameSummary.vue?vue&type=template&id=71185fb8&"
import script from "./GameSummary.vue?vue&type=script&lang=js&"
export * from "./GameSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports